import { useRef } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { InventoryCountForm } from "@/components/inventory-counts/inventory-count-form";
import { Id } from "@/convex/_generated/dataModel";

export const Route = createFileRoute("/_authenticated/inventory-counts/new")({
  validateSearch: (search: Record<string, unknown>) => ({
    draft: typeof search.draft === "string" ? search.draft : undefined,
  }),
  component: NewInventoryCountPage,
});

function NewInventoryCountPage() {
  const { draft } = Route.useSearch();
  const navigate = useNavigate();
  const coldDraftRef = useRef(draft);
  return (
    <RouteGuardPermissions
      permissions={[{ module: "inventory_counts", actions: ["create"] }]}
    >
      <InventoryCountForm
        countId={
          coldDraftRef.current
            ? (coldDraftRef.current as Id<"inventory_counts">)
            : undefined
        }
        onDraftCreated={(id) =>
          navigate({
            to: "/inventory-counts/new",
            search: { draft: id },
            replace: true,
          })
        }
      />
    </RouteGuardPermissions>
  );
}
